import { useTranslation } from 'react-i18next';

interface StepProps {
  number: number;
  titleKey: string;
  descriptionKey: string;
}

const Step = ({ number, titleKey, descriptionKey }: StepProps) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-lg shadow-sm p-5 flex items-center gap-4">
      {/* Number Circle */}
      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-primary flex items-center justify-center">
        <span className="text-white text-xl font-bold">{number}</span>
      </div>

      {/* Content */}
      <div className="flex-1">
        <h3 className="text-lg font-bold mb-2">{t(titleKey)}</h3>
        <p className="text-sm text-muted-foreground leading-relaxed">
          {t(descriptionKey)}
        </p>
      </div>
    </div>
  );
};

export const HowItWorks = () => {
  const { t } = useTranslation();
  const steps = [
    {
      number: 1,
      titleKey: 'landing.howItWorks.step1.title',
      descriptionKey: 'landing.howItWorks.step1.description',
    },
    {
      number: 2,
      titleKey: 'landing.howItWorks.step2.title',
      descriptionKey: 'landing.howItWorks.step2.description',
    },
    {
      number: 3,
      titleKey: 'landing.howItWorks.step3.title',
      descriptionKey: 'landing.howItWorks.step3.description',
    },
  ];

  return (
    <div className="bg-muted rounded-lg p-6 md:p-8 w-full mb-8">
      {/* Title */}
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-6">
        {t('landing.howItWorks.title')}
      </h2>

      {/* Steps */}
      <div className="flex flex-col gap-4">
        {steps.map((step) => (
          <Step
            key={step.number}
            number={step.number}
            titleKey={step.titleKey}
            descriptionKey={step.descriptionKey}
          />
        ))}
      </div>
    </div>
  );
};
